export const KPI_GROUP = {
  AREAS: 'Areas',
  DEPARTMENTS: 'Departments'
} as const

export type KpiGroup = (typeof KPI_GROUP)[keyof typeof KPI_GROUP]

export type KpiOption = {
  id: string
  label: string
  group?: KpiGroup
}
